import React from "react"
import { blockingFetchService } from "../../../lib/blockingFetch"
import { validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FormControlInlineInput from "../../fragments/FormControl.Inline.Input"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import SimpleForm from "../../fragments/SimpleForm"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"

export default class FormInvestor extends React.Component {

  constructor(props) {

    super(props)
    const { investor } = this.props,
    isNew = !investor

    this.state = {

      isNew,
      running: false,
      success: false,
      error: null,
      name: investor && investor.name ? investor.name : '',
      bankName: investor && investor.bankName ? investor.bankName : '',
      walletAddress: investor && investor.walletAddress ? investor.walletAddress : '',
      nameValidationState: VALIDATION_TYPE.NULL,
      bankNameValidationState: VALIDATION_TYPE.NULL,
      walletAddressValidationState: VALIDATION_TYPE.NULL,
    }
  }

  nameChanged = name => this.setState({
    name,
    nameValidationState: validateTextState(name, false),
    error: null,
  })

  bankNameChanged = bankName => this.setState({
    bankName,
    bankNameValidationState: validateTextState(bankName, true),
    error: null,
  })

  walletAddressChanged = walletAddress => this.setState({
    walletAddress,
    walletAddressValidationState: validateTextState(walletAddress, true),
    error: null,
  })

  validateData = () => {

    const { name, bankName, walletAddress } = this.state,
    nameValid = validateTextState(name, false),
    bankNameValid = validateTextState(bankName, true),
    walletAddressValid = validateTextState(walletAddress, true)

    this.setState({
      nameValidationState: nameValid,
      bankNameValidationState: bankNameValid,
      walletAddressValidationState: walletAddressValid
    })

    return nameValid === VALIDATION_TYPE.SUCCESS
      && bankNameValid !== VALIDATION_TYPE.ERROR
      && walletAddressValid !== VALIDATION_TYPE.ERROR
  }

  saveData = () => {

    if(!this.validateData()) {
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, name, bankName, walletAddress  } = this.state,
    data = { name, bankName, walletAddress },
    { investor } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.saveInvestor(accessToken, data)
        : apiServerApi.updateInvestor(accessToken, investor.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(this.back, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  back = () => browserHistory.push('/financiers/investors')

  renderForm = () => {

    const { investor } = this.props,
    title = investor ? <span>Update &#171; { investor.name } &#187;</span> : 'Add Investor',

    { name, bankName, walletAddress, nameValidationState, bankNameValidationState,
      walletAddressValidationState, running, success, error } = this.state

    return (
      <SimpleForm
        title={ title }
        onSave={ this.saveData }
        onCancel={ this.back }
        running={ running }>

        <FormControlInlineInput controlId="name" validationState={ nameValidationState }
          label='Investor name *' placeholder='Enter name' value={ name }
          onChange={ this.nameChanged }
          helpText={ nameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
          disabled={ running }
        />

        <FormControlInlineInput controlId="bankName" validationState={ bankNameValidationState }
          label='Bank name' placeholder='Bank name' value={ bankName }
          onChange={ this.bankNameChanged }
          disabled={ running }
        />

        <FormControlInlineInput controlId="walletAddress" validationState={ walletAddressValidationState }
          label='Wallet address' placeholder='0x657...' value={ walletAddress }
          onChange={ this.walletAddressChanged }
          disabled={ running }
        />

        <ProcessesStatus error={ error } running={ running } success={ success } />

      </SimpleForm>
    )
  }

  render() {

    const { isNew } = this.state,
    breadCrumbData = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/investors', title: 'Investors' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ breadCrumbData } />
        { this.renderForm() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Form.js